<template>
  <div>
    <h5 class="section-title">{{ $t("pages.wording.reserveTitle") }}</h5>
    <CardTable>
      <!-- 預約單號 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.reserveNo") }}</div>
        <div class="value">{{ infoData.reserveData.reserveNo }}</div>
      </div>
      <!-- 狀態 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.reserveStatus") }}</div>
        <div class="value">{{ $t("reserve.status." + infoData.reserveData.reserveStatus) }}</div>
      </div>
      <!-- 公司名稱 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.vendor") }}</div>
        <div class="value">{{ infoData.reserveData.vendor }}</div>
      </div>
      <!-- 入廠事由 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.enterReason") }}</div>
        <div class="value">{{ $store.getters.getSysCodeText("enterReason", infoData.reserveData.enterReason) }}</div>
      </div>
      <!-- 車牌號碼 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.carPlat") }}</div>
        <div class="value">
          {{ infoData.reserveData.tempCar ? infoData.reserveData.tmpCarPlat : infoData.reserveData.carPlat }}
        </div>
      </div>
      <!-- 駕駛員姓名/駕駛員證號 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.driverName") }}/{{ $t("pages.wording.driverID") }}</div>
        <div class="value">{{ infoData.reserveData.driverName }} / {{ infoData.reserveData.driverID }}</div>
      </div>
      <!-- 攜帶物 -->
      <span v-if="infoData.carringData.length > 0">
        <div class="card-item" v-for="(item, index) in infoData.carringData" :key="item.id">
          <div class="label">{{ $t("pages.wording.carring") }}{{ index + 1 }}/{{ $t("pages.wording.qty") }}</div>
          &nbsp;
          <div class="value">
            {{ $store.getters.getSysCodeText("carringType", item.carring) }} / {{ item.carringType }}
          </div>
        </div>
      </span>
      <!-- 隨行人數 -->
      <span v-if="infoData.entourageData.length > 0">
        <div class="card-item" v-for="(item, index) in infoData.entourageData" :key="item.id">
          <div class="label">{{ $t("pages.wording.entourage") }}{{ index + 1 }}/{{ $t("pages.wording.idNum") }}</div>
          <div class="value">{{ item.entourageName }} / {{ item.entourageID }}</div>
        </div>
      </span>
    </CardTable>
    <h5 class="section-title">{{ $t("pages.wording.inspectStatus") }}</h5>
    <CardTable>
      <!-- 進廠檢查 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.entering") }}</div>
        <div class="value">
          {{ $t("reserve.status." + infoData.inspectData.entering) }}
          <span class="form-button" @click="linkClick('entering')">
            <span> <i class="el-icon-document"></i>{{ $t("pages.wording.inspectorForm") }}</span>
          </span>
        </div>
      </div>
      <!-- 出廠初檢 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.in1") }}</div>
        <div class="value">
          {{ $t("reserve.status." + infoData.inspectData.in1) }}
          <span class="form-button" @click="linkClick('in1')">
            <span> <i class="el-icon-document"></i>{{ $t("pages.wording.inspectorForm") }}</span>
          </span>
        </div>
      </div>
      <!-- 出廠複檢 -->
      <div class="card-item">
        <div class="label">{{ $t("pages.wording.in2") }}</div>
        <div class="value">
          {{ $t("reserve.status." + infoData.inspectData.in2) }}
          <span class="form-button" @click="linkClick('in2')">
            <span> <i class="el-icon-document"></i>{{ $t("pages.wording.inspectorForm") }}</span>
          </span>
        </div>
      </div>
    </CardTable>
  </div>
</template>

<script>
import CardTable from "@/components/common/CardTable.vue"

export default {
  name: "GuardBasicInfo",
  props: {
    infoData: Object,
  },
  components: {
    CardTable,
  },
  data() {
    return {}
  },
  mounted() {
    this.buildData()
  },
  methods: {
    buildData() {
      let driverID =
        this.infoData.reserveData.tempCar == false
          ? this.infoData.reserveData.driverID
          : this.infoData.reserveData.tmpDriverID
      let driverName =
        this.infoData.reserveData.tempCar == false
          ? this.infoData.reserveData.driverName
          : this.infoData.reserveData.tmpDriverName

      this.infoData.reserveData.driverName = driverName
      this.infoData.reserveData.driverID = driverID
    },
    linkClick(collapseName) {
      this.$emit("linkClick", collapseName)
    },
  },
}
</script>

<style scoped>
.CardTable:not(:last-child) {
  margin-bottom: 24px;
}
.section-title {
  margin-bottom: 16px;
  font-weight: bold;
  font-size: var(--subTitle-font-size);
  line-height: var(--subTitle-line-height);
}
.form-button {
  color: var(--blue500);
  font-size: var(--button-font-size);
  line-height: var(--button-line-height);
  font-weight: 700;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 8px;
  margin-left: 16px;
}
.form-button i {
  font-size: 18px;
  margin-right: 4px;
}
</style>
